import { Routes } from '@angular/router';
import { AdminPanel } from './components/admin-panel/admin-panel';

export const routes: Routes = [
  {
    path: 'admin',
    component: AdminPanel,
  },
];
